








import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ChallengerDetailCommunityUser from './ChallengerDetailCommunityUser.vue';
import { UserModel } from '@/models/user.model';
import { challengeCommunityModule } from '@/utils/store-acessor';

@Component({
  components: {
    ChallengerDetailCommunityUser
  }
})
export default class ChallengerDetailCommunityUsers extends Vue {
  @challengeCommunityModule.Getter('users') users!: UserModel[];
}
